<template>
  <div>
    <PageTitle title="Reservation Reports" />
    <v-container fluid class="lighten-12 content">
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="['search', 'dateRange', 'reservationstatus', 'guest', 'biller']"
          :columns="columns"
          v-model="filter"
          :export="[`productexport`]"
          @clear="onClearFilters"
        ></TableFilters>
        <v-row class="py-0 my-0">
          <v-col cols="12" class="py-0 my-0">
            <v-row class="py-0 my-0">
              <v-col cols="auto" class="py-1 pr-2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      v-bind="attrs"
                      v-on="on"
                      shaped
                      block
                      height="30px"
                      class="report-button"
                      color="blue"
                      @click="
                        generateReport();
                        hide = true;
                      "
                    >
                      <v-icon small>mdi-file-send </v-icon>Generate
                    </v-btn>
                  </template>
                  <span>Genarate</span>
                </v-tooltip>
              </v-col>
              <v-col cols="auto" class="py-1 pr-2" v-if="hide"><v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }"
                    ><v-btn
                      depressed
                      v-bind="attrs"
                      v-on="on"
                      class="report-button"
                      color="red"
                      height="30px"
                      block
                      @click="exportPDF()"
                    >
                      <v-icon small>mdi-file-pdf </v-icon>Export
                    </v-btn>
                  </template>
                  <span>Export to PDF</span>
                </v-tooltip></v-col
              >
              <v-col cols="auto" class="py-1 pr-2" v-if="hide">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      height="30px"
                      v-bind="attrs"
                      v-on="on"
                      block
                      class="report-button"
                      color="green"
                      @click="exceldownload()"
                    >
                      <v-icon small>mdi-file-excel </v-icon>Export
                    </v-btn>
                  </template>
                  <span>Export to Excel</span>
                </v-tooltip></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mt-2">
        <v-container fluid class="light gray lighten-12">
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                 :v-model:options="pagination"
                :items-per-page="pagination.itemsPerPage"
                :items-per-page-options="[5, 10, 20, 50, 100, 1000, -1]"
                :fixed-header="true"
                height="65vh"
                :headers="headers"
                :items="reservation"
                item-key="id"
                class="row-pointer"
                id="indextable"
              >
                <template v-slot:no-data>
                  <div class="mt-16 container justify-center item-center">
                    <noData name="reservation" />
                  </div>
                </template>
                <template v-slot:item.date="{ item }">{{
                  item.date | formatDate
                }}</template>
                <template v-slot:item.guest="{ item }">{{
                  item.guest && item.guest.name ? item.guest.name : "-"
                }}</template>
                <template v-slot:item.user="{ item }">{{
                  item.user && item.user.last_name ? item.user.last_name : "-"
                }}</template>
                <template v-slot:item.rooms="{ item }">
                  <div v-for="(room, index) in item.rooms || []" :key="index">
                    {{ room.room ? room.room.name : "" }}
                    - {{ room.check_in | formatDate }}
                    - {{ room.check_out | formatDate }}
                  </div>
                </template>

                <template
                  slot="body.append"
                  v-if="reservation && reservation.length > 0"
                >
                  <tr class="black--text">
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>

                    <th class="title"></th>

                    <th>
                      <h3 class="title">
                        {{ roomtotalamount | formatCurrency }}
                      </h3>
                    </th>
                    <th>
                      <h3 class="title">
                        {{ ordertotalamount | formatCurrency }}
                      </h3>
                    </th>
                    <th>
                      <h3 class="title">
                        {{ paidamount | formatCurrency }}
                      </h3>
                    </th>
                    <th>
                      <h3 class="title">
                        {{ total | formatCurrency }}
                      </h3>
                    </th>
                    <th class="title"></th>

                    <th class="title"></th>
                    <!-- <th class="title"></th> -->
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// Components
import PageTitle from "@/components/shared/PageTitle";
import TableFilters from "@/components/base/TableFilters";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import XLSX from "xlsx";
import { DateTime } from "@grapecity/wijmo";
import moment from "moment";
import _ from "lodash";
export default {
  data: () => ({
    messages: [],
    status: [
      { text: "Active", value: "active" },
      { text: "Archived", value: "archived" },
    ],
    columns: [
      {
        text: "Number",
        value: "no",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Date",
        value: "date",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Reference Number",
        value: "reference_number",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Guest",
        value: "guest",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Rooms",
        value: "rooms",
        show: true,
        disabled: false,
        width: "14%",
      },

      {
        text: "Room Total Amount",
        value: "room_total_amount",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Order Total Amount",
        value: "order_total_amount",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Paid Amount",
        value: "paid_amount",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Total Amount",
        value: "total_amount",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Status",
        value: "status",
        show: true,
        disabled: false,
        width: "14%",
      },

      {
        text: "User",
        value: "user",
        show: true,
        disabled: false,
        width: "14%",
      },
    ],
     pagination: {
    page: 1,
    itemsPerPage: -1,
  },
    reservation: [],
    date_range: [],
    total: 0,
    paidamount: 0,
    roomtotalamount: 0,
    ordertotalamount: 0,
    // Filters
    filter: {
      search: "",
      start: "",
      end: "",
      guest: "",
    },
  }),
  components: {
    PageTitle,
    TableFilters,
  },

  mounted() {
    this.generateReport();
  },

  methods: {
    dateFormat: function(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[filed]);
      });
      return value;
    },

    generateReport() {
      var filter = this.filter;
      if (filter.start && !filter.end) {
        filter.end = moment(filter.start)
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        filter.start = moment(filter.start)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      }

      if (filter.start && filter.end) {
        filter.start = moment(filter.start)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        filter.end = moment(filter.end)
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      this.$store
        .dispatch("report/getReservationReports", filter)
        .then((res) => {
          let i = 1;
          this.reservation = res.data.data;
          console.log("Reservation Report Data Length:", this.reservation.length);
          this.reservation.map((p) => {
            p.no = i;
            i++;
          });
          this.total = this.sumField(this.reservation, "total_amount");
          this.roomtotalamount = this.sumField(
            this.reservation,
            "room_total_amount"
          );
          this.ordertotalamount = this.sumField(
            this.reservation,
            "order_total_amount"
          );
          this.paidamount = this.sumField(this.reservation, "paid_amount");
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    exportPDF() {
      const today = new DateTime();
      let Data = _.cloneDeep(this.reservation);

      for (let x = 0; x < Data.length; x++) {
        Data[x].date = moment(Data[x].date, "YYYY-MM-DD").format("DD/MM/YYYY");
        Data[x].guest = Data[x].guest ? Data[x].guest.name : "-";
        Data[x].user = Data[x].user ? Data[x].user.last_name : "-";
        Data[x].rooms = Data[x].rooms
          ? Data[x].rooms
              .map((r) => {
                let roomName = r.room ? r.room.name : "-";
                return `${roomName} (${moment(r.check_in).format(
                  "DD/MM/YYYY"
                )} - ${moment(r.check_out).format("DD/MM/YYYY")})`;
              })
              .join(", ")
          : "-";
      }
      var rows = Data;
      var doc = jsPDF({
        orientation: "landscape",
      });
      doc.setFontSize(14);
      // doc.setFontType("bold");
      doc.setTextColor(26, 26, 26);
      doc.setFont("helvetica", "bold");
      doc.text("Reservation Report", 130, 5);

      doc.setFontSize(11);
      doc.text(15, 5, `${moment(today).format("DD-MM-YYYY HH:MM:SS")}`);

      doc.setFontSize(11);
      doc.text(15, 12, `Total Amount :- ${this.total}.00`);
      doc.text(100, 12, `Paid Total :- ${this.paidamount}.00`);
      doc.text(170, 12, `Order Total :- ${this.ordertotalamount}.00`);
      doc.text(240, 12, `Room Charge:- ${this.roomtotalamount}.00`);
      doc.autoTable(
        this.headers.map((h) => {
          return { title: h.text, dataKey: h.value };
        }),
        rows,
        {
          didParseCell: function(data) {
            if (data.column.dataKey === "addsress") {
              data.cell.text = data.cell.raw.country;
            }
          },
        }
      );
      doc.save(`${moment(today).format("DD-MM-YYYY")}-reservation.pdf`);
    },
    //Product Details Export Excel
    exceldownload() {
      var data = document.getElementById("indextable");
      const today = new DateTime();
      const headData = XLSX.utils.table_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        headData,
        moment(today).format("DD-MM-YYYY")
      );
      XLSX.writeFile(
        wb,
        `${moment(today).format("DD-MM-YYYY")}-reservation.xlsx`
      );
    },
    onClearFilters() {
      this.products = [];
      this.hide = false;

      this.$nextTick(() => {
        this.generateReport();
      });
    },
  },
  computed: {
    dateRangeText() {
      this.filter.start = this.date_range[0];
      this.filter.end = this.date_range[1];
      return this.date_range.join(" ~ ");
    },
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>
